import { reactive } from "vue";
import { appStore } from "../../stores/app";

/** Placements offered in the placement popup (e.g. "back", "center", "front"). */
export const placementPopup = reactive({
    placements: [] as string[],
});

let answer: ((placement: string | undefined) => void) | null = null;

/** Shows the placement popup and resolves with the chosen placement, or undefined for "no placement". */
export function askPlacement(placements: string[]): Promise<string | undefined> {
    placementPopup.placements = placements;
    appStore.modal = "placement";
    return new Promise(resolve => { answer = resolve; });
}

export function answerPlacement(placement: string | undefined) {
    appStore.modal = null;
    answer?.(placement);
    answer = null;
}
